import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxPrintModule } from 'ngx-print';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SharedModule } from '../shared.module';

import { CommonReturnViewComponent } from './common-return-view.component';
import { ReturnViewContentComponent } from './return-view-content.component';

import { TaxpayerBasicInfoV2Component } from './sections/bn/taxpayer-basic-info-v2/taxpayer-basic-info-v2.component';
import { IncomeTaxDetailsV2Component } from './sections/bn/income-tax-details-v2/income-tax-details-v2.component';
import { ResourceLiabilitiesExpensesV2Component } from './sections/bn/resource-liabilities-expenses-v2/resource-liabilities-expenses-v2.component';
import { AgriIncomeReturnV2Component } from './sections/bn/agri-income-return-v2/agri-income-return-v2.component';
import { BusinessIncomeReturnV2Component } from './sections/bn/business-income-return-v2/business-income-return-v2.component';
import { InvestmentRebateInfoV2Component } from './sections/bn/investment-rebate-info-v2/investment-rebate-info-v2.component';
import { RegularLivingExpensesV2Component } from './sections/bn/regular-living-expenses-v2/regular-living-expenses-v2.component';
import { JobIncomeReturnV2Component } from './sections/bn/job-income-return-v2/job-income-return-v2.component';
import { RentIncomeReturnV2Component } from './sections/bn/rent-income-return-v2/rent-income-return-v2.component';
import { ReturnFillupInstructionsV2Component } from './sections/bn/return-fillup-instructions-v2/return-fillup-instructions-v2.component';
import { TdsInfoReturnV2Component } from './sections/bn/tds-info-return-v2/tds-info-return-v2.component';
import { CsrInfoReturnComponent } from './sections/csr-info-return/csr-info-return.component';

import { AgriIncomeReturnEnV2Component } from './sections/en/agri-income-return-en-v2/agri-income-return-en-v2.component';
import { BusinessIncomeReturnEnV2Component } from './sections/en/business-income-return-en-v2/business-income-return-en-v2.component';
import { IncomeTaxDetailsEnV2Component } from './sections/en/income-tax-details-en-v2/income-tax-details-en-v2.component';
import { InvestmentRebateInfoEnV2Component } from './sections/en/investment-rebate-info-en-v2/investment-rebate-info-en-v2.component';
import { JobIncomeReturnEnV2Component } from './sections/en/job-income-return-en-v2/job-income-return-en-v2.component';
import { RegularLivingExpensesEnV2Component } from './sections/en/regular-living-expenses-en-v2/regular-living-expenses-en-v2.component';
import { RentIncomeReturnEnV2Component } from './sections/en/rent-income-return-en-v2/rent-income-return-en-v2.component';
import { ResourceLiabilitiesExpensesEnV2Component } from './sections/en/resource-liabilities-expenses-en-v2/resource-liabilities-expenses-en-v2.component';
import { ReturnFillupInstructionsEnV2Component } from './sections/en/return-fillup-instructions-en-v2/return-fillup-instructions-en-v2.component';
import { TaxpayerBasicInfoEnV2Component } from './sections/en/taxpayer-basic-info-en-v2/taxpayer-basic-info-en-v2.component';
import { NonagriAgriPropertyValuesEnV2Component } from './sections/en/nonagri-agri-property-values-en-v2/nonagri-agri-property-values-en-v2.component';
import { BusinessCapitalEnV2Component } from './sections/en/business-capital-en-v2/business-capital-en-v2.component';
import { FinancialAssetsEnV2Component } from './sections/en/financial-assets-en-v2/financial-assets-en-v2.component';
import { MotorCarEnV2Component } from './sections/en/motor-car-en-v2/motor-car-en-v2.component';
import { SourceFundEnV2Component } from './sections/en/source-fund-en-v2/source-fund-en-v2.component';
import { LiabilitiesEnV2Component } from './sections/en/liabilities-en-v2/liabilities-en-v2.component';
import { UndisclosedIncomeEnV2Component } from './sections/en/undisclosed-income-en-v2/undisclosed-income-en-v2.component';
import { IncomeFromEmploymentEnV2Component } from './sections/en/income-from-employment-en-v2/income-from-employment-en-v2.component';
import { IncomeFromFinancialAssetsEnV2Component } from './sections/en/income-from-financial-assets-en-v2/income-from-financial-assets-en-v2.component';
import { IncomeFromRentEnV2Component } from './sections/en/income-from-rent-en-v2/income-from-rent-en-v2.component';
import { IncomeFromAgricultureEnV2Component } from './sections/en/income-from-agriculture-en-v2/income-from-agriculture-en-v2.component';
import { IncomeFromBusinessEnV2Component } from './sections/en/income-from-business-en-v2/income-from-business-en-v2.component';
import { IncomeFromCapitalGainEnV2Component } from './sections/en/income-from-capital-gain-en-v2/income-from-capital-gain-en-v2.component';
import { IncomeFromFirmEtcEnV2Component } from './sections/en/income-from-firm-etc-en-v2/income-from-firm-etc-en-v2.component';
import { IncomeFromOtherSourcesEnV2Component } from './sections/en/income-from-other-sources-en-v2/income-from-other-sources-en-v2.component';
import { IncomeFromTaxExemptedIncomeEnV2Component } from './sections/en/income-from-tax-exempted-income-en-v2/income-from-tax-exempted-income-en-v2.component';
import { IncomeFromVoluntaryDisclosureEnV2Component } from './sections/en/income-from-voluntary-disclosure-en-v2/income-from-voluntary-disclosure-en-v2.component';
import { RebateDetailssEnV2Component } from './sections/en/rebate-detailss-en-v2/rebate-detailss-en-v2.component';
import { AssetsAndLiabilitiesDetailsEnV2Component } from './sections/en/assets-and-liabilities-details-en-v2/assets-and-liabilities-details-en-v2.component';

const RETURN_VIEW_SECTION_COMPONENTS = [
  TaxpayerBasicInfoV2Component,
  IncomeTaxDetailsV2Component,
  ResourceLiabilitiesExpensesV2Component,
  AgriIncomeReturnV2Component,
  BusinessIncomeReturnV2Component,
  InvestmentRebateInfoV2Component,
  RegularLivingExpensesV2Component,
  JobIncomeReturnV2Component,
  RentIncomeReturnV2Component,
  ReturnFillupInstructionsV2Component,
  TdsInfoReturnV2Component,
  CsrInfoReturnComponent,
  AgriIncomeReturnEnV2Component,
  BusinessIncomeReturnEnV2Component,
  IncomeTaxDetailsEnV2Component,
  InvestmentRebateInfoEnV2Component,
  JobIncomeReturnEnV2Component,
  RegularLivingExpensesEnV2Component,
  RentIncomeReturnEnV2Component,
  ResourceLiabilitiesExpensesEnV2Component,
  ReturnFillupInstructionsEnV2Component,
  TaxpayerBasicInfoEnV2Component,
  NonagriAgriPropertyValuesEnV2Component,
  IncomeFromEmploymentEnV2Component,
  IncomeFromFinancialAssetsEnV2Component,
  IncomeFromRentEnV2Component,
  IncomeFromAgricultureEnV2Component,
  IncomeFromBusinessEnV2Component,
  IncomeFromCapitalGainEnV2Component,
  IncomeFromFirmEtcEnV2Component,
  IncomeFromOtherSourcesEnV2Component,
  IncomeFromTaxExemptedIncomeEnV2Component,
  IncomeFromVoluntaryDisclosureEnV2Component,
  RebateDetailssEnV2Component,
  AssetsAndLiabilitiesDetailsEnV2Component,
  BusinessCapitalEnV2Component,
  FinancialAssetsEnV2Component,
  MotorCarEnV2Component,
  SourceFundEnV2Component,
  LiabilitiesEnV2Component,
  UndisclosedIncomeEnV2Component
];

const COMMON_RETURN_VIEW_DECLARATIONS: any[] = [
  CommonReturnViewComponent,
  ReturnViewContentComponent,
  ...RETURN_VIEW_SECTION_COMPONENTS
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxPrintModule,
    NgxUiLoaderModule,
    ModalModule
  ],
  declarations: COMMON_RETURN_VIEW_DECLARATIONS,
  exports: [
    CommonReturnViewComponent,
    ReturnViewContentComponent,
    TdsInfoReturnV2Component
  ]
})
export class CommonReturnViewModule { }
